import React from 'react';
import '../styles/DomainList.css';

function getStatusDot(status) {
  switch (status) {
    case 'active':
      return { color: '#10b981', label: 'Active' };
    case 'pending':
    case 'registering':
      return { color: '#f59e0b', label: 'Pending' };
    case 'expired':
    case 'failed':
      return { color: '#ef4444', label: status.charAt(0).toUpperCase() + status.slice(1) };
    default:
      return { color: '#64748b', label: status || 'Unknown' };
  }
}

export default function DomainList({ domains, selectedId, onSelect, loading }) {
  if (loading) {
    return (
      <div className="domain-list">
        <div className="domain-list-empty">Loading domains...</div>
      </div>
    );
  }

  if (!domains || domains.length === 0) {
    return (
      <div className="domain-list">
        <div className="domain-list-empty">
          <p>No domains yet.</p>
          <p className="domain-list-hint">
            Start a conversation to get one registered.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="domain-list">
      {domains.map((domain) => {
        const status = getStatusDot(domain.status);
        return (
          <button
            key={domain.id}
            className={`domain-list-item ${domain.id === selectedId ? 'selected' : ''}`}
            onClick={() => onSelect(domain.id)}
          >
            <span
              className="domain-status-dot"
              style={{ backgroundColor: status.color }}
              title={status.label}
            />
            <span className="domain-list-name">{domain.domain_name}</span>
          </button>
        );
      })}
    </div>
  );
}
